import './TermsAndConditions.css'
import React from 'react';

const TermsAndConditions: React.FC = () => {
    return (
        <div className="tac-modal">
            <div className="content">
                <div className="header">
                    <div className="text">個人情報保護方針</div>
                </div>
                <div className="text-container">
                    <div className="right-align">
                        制定年月日　2019年9月1日<br />
                        最終改正年月日　2021年4月1日<br />
                        株式会社はばたーく<br />
                        代表取締役 中村　和博
                    </div>
                    <p className='para'>
                        当社は、当社が取り扱う全ての個人情報の保護について、社会的使命を十分に認識し、本人の権利  
                        の保護、個人情報に関する法規制等を遵守します。また、以下に示す方針を具現化するための個人情 
                        報保護マネジメントシステムを構築し、最新のＩＴ技術の動向、社会的要請の変化、経営環境の変動
                        等を常に認識しながら、その継続的改善に、全社を挙げて取り組むことをここに宣言します。
                    </p>
                    
                    <div className='bold para'>
                        <p className="num">a)</p>
                        <p className="str">個人情報は、ITソリューションサービス、システム開発業務、システムエンジニアリング
                        サービス業務における当社の正当な事業遂行上並びに従業員の雇用、人事管理上必要な範囲に
                        限定して、取得・利用及び提供をし、特定された利用目的の達成に必要な範囲を超えた個人情
                        報の取扱い（目的外利用）を行いません。また、目的外利用を行わないための措置を講じます。</p>
                    </div>
                    
                    <div className='bold para'>
                        <p className="num">b)</p>
                        <p className="str">個人情報保護に関する法令、国が定める指針及びその他の規範を遵守致します。</p>
                    </div>
                    
                    <div className='bold para'>
                        <p className="num">c)</p>
                        <p className="str">個人情報の漏えい、滅失、き損などのリスクに対しては、合理的な安全対策を講
                        じて防止すべく事業の実情に合致した経営資源を注入し個人情報セキュリティ体制を継続的に向上させます。
                        また、個人情報保護上、問題があると判断された場合には速やかに是正措置を講じます。</p>
                    </div>
                    
                    <div className='bold para'>
                        <p className="num">d)</p>
                        <p className="str">個人情報取扱いに関する苦情及び相談に対しては、迅速かつ誠実に、適切な対応をさせ
                        ていただきます。</p>
                    </div>

                    <div className='bold para'>
                        <p className="num">e)</p>
                        <p className="str">個人情報保護マネジメントシステムは、当社を取り巻く環境の変化を踏まえ、適時・適切に見直
                        してその改善を継続的に推進します。</p>
                    </div>

                    <div className="right-align">以上</div>

                    <div className='para'>
                        <span className="bold">【お問合せ窓口】</span><br />
                        個人情報保護方針に関するお問合せにつきましては、下記窓口で受付けております。
                    </div>

                    <div className="bordered-box"> 
                        株式会社はばたーく 　個人情報問合せ窓口<br />
                        東京都中央区日本橋本町4-8-15　ネオカワイビル<br />
                        TEL: 03-4530-0076  FAX: 03-4530-0002<br />
                        メールアドレス: <span className='highlight'>pmarkteam@haveatalk.jp</span><br />
                        受付時間: 9:30～18:00(土・日曜日、祝日、年末年始、ゴールデンウィークを除く)
                    </div>

                    <br />

                    <p className='para'>（個人情報に関する公表文）</p>

                    <div className='para'>
                        <div className="bold mb-15">■ 個人情報の取扱いについて</div>
                        <div className="indent-level-one">当社が取り扱う個人情報の利用目的は以下となります。</div>
                        <div className="indent-level-two mb-15">
                            <div className='bold'>1.お客様情報</div>
                            <div className="indent-level-one">
                                ・ユーザー様サポートのため<br />
                                ・ご利用履歴管理のため<br />
                                ・当社サービスのご案内のため<br />
                                ・お問合せ対応のため<br />
                            </div>
                        </div>
                        <div className="indent-level-two mb-15">
                            <div className='bold'>2.業務の受託に伴い、お客様からお預かりする個人情報</div>
                            <div className="indent-level-one">
                                ・給与計算業務等の委託された当該業務を適切に遂行するため
                            </div>
                        </div>
                        <div className="indent-level-two mb-15">
                            <div className='bold'>3.お取引先担当者様情報</div>
                            <div className="indent-level-one">
                                ・セミナー、製品、サービスの案内・情報提供のため<br />
                                ・委託業務内容の打診・紹介のため
                            </div>
                        </div>
                        <div className="indent-level-two mb-15">
                            <div className='bold'>4.当社従業員情報</div>
                            <div className="indent-level-one">
                                ・社員の人事労務管理、業務管理、健康管理、セキュリティ管理のため
                            </div>
                        </div>
                        <div className="indent-level-two mb-15">
                            <div className='bold'>5.当社への採用応募者情報</div>
                            <div className="indent-level-one">
                                ・採用応募者への連絡と当社の採用業務管理のため
                            </div>
                        </div>
                        <div className="indent-level-two mb-15">
                            <div  className='bold'>6.特定個人情報</div>
                            <div className="indent-level-one">
                                ・番号法に定められた利用目的のため
                            </div>
                        </div>
                        <div className="indent-level-two mb-15">
                            <div  className='bold'>7.グループ会社社員の個人情報</div>
                            <div className="indent-level-one">
                                ・営業活動や常駐先の選定のため
                            </div>
                        </div>
                    </div>

                    <div className='para'>
                        <div className="bold mb-15">■ 個人情報の共同利用</div>
                        <div className="indent-level-one" >当社では、以下の通り個人情報の共同利用を行っております。</div>
                        <div className="indent-level-two mb-15">
                            <div className='bold'>1.共同して利用される個人情報の項目</div>
                            <div className="indent-level-one">
                                ・氏名、会社名、メールアドレス、電話番号、住所、履歴書、職務経歴書 等
                            </div>
                        </div>
                        <div className="indent-level-two mb-15">
                            <div className='bold'>2.共同して利用する者の範囲</div>
                            <div className="indent-level-one">
                                ・当社親会社である「株式会社アクロホールディングス」
                            </div>
                        </div>
                        <div className="indent-level-two mb-15">
                            <div className='bold'>3.共同して利用する者の利用目的</div>
                            <div className="indent-level-one">
                                ・採用選考のため、採用選考に関わる連絡のため、入社などの手続きのため
                            </div>
                        </div>
                        <div className="indent-level-two mb-15">
                            <div className='bold'>
                                4.共同して利用する個人情報の管理について責任を有する者の氏名又は名称及び住所並びに法人に<br />
                                　あっては、その代表者の氏名
                            </div>
                            <div className="indent-level-one">
                                ・株式会社アクロホールディングス 代表取締役 西川 慶<br />
                                　東京都中央区日本橋本町4-8-15 ネオカワイビル 6F<br />
                            </div>
                        </div>
                        <div className="indent-level-two mb-15">
                            <div className='bold'>5.取得方法</div>
                            <div className="indent-level-one">
                                ・各種採用媒体や取引先企業からのご紹介による
                            </div>
                        </div>
                    </div>

                    <div className='para'>
                        <div className="bold mb-15">■ 保有個人データに関する事項の周知</div>
                        <div className="indent-level-one" >
                            当社で保有している保有個人データ又は第三者提供記録に関して、ご本人様又はその代理人様から
                            の利用目的の通知、 開示、内容の訂正、追加又は削除、利用の停止、消去及び第三者への提供の停止の請求
                            （以下、 「開示等の請求」といいます）につきましては、以下の要領にて対応させていただきます。
                        </div>
                        <div className="indent-level-two mb-15">
                            <div className='bold'>1.事業者の名称</div>
                            <div className="indent-level-one">
                                ・株式会社はばたーく　代表取締役　中村 和博
                            </div>
                        </div>
                        <div className="indent-level-two mb-15">
                            <div className='bold'>2.個人情報保護管理者</div>
                            <div className="indent-level-one">
                                ・システム部 　尾崎 高太 　TEL:03-4530-0076
                            </div>
                        </div>
                        <div className="indent-level-two mb-15">
                            <div className='bold'>3.全ての保有個人データの利用目的</div>
                            <div className="indent-level-one">
                                ・上記「■個人情報の取扱いについて」の内容に同じです。<br />
                                　なお、「2.業務の受託に伴い、お客様からお預かりする個人情報」は開示対象外とします。
                            </div>
                        </div>
                        <div className="indent-level-two mb-15">
                            <div className='bold'>4.保有個人データの取扱いに関する苦情の申し出先</div>
                            <div className="indent-level-one">
                                ・株式会社はばたーく  個人情報問合せ窓口<br />
                                東京都中央区日本橋本町4-8-15 ネオカワイビル<br />
                                TEL: 03-4530-0076 FAX: 03-4530-0002<br />
                                メールアドレス: pmarkteam@haveatalk.jp<br />
                                受付時間: 9:30～18:00(土・日曜日、祝日、年末年始、ゴールデンウィークを除く)
                            </div>
                        </div>
                        <div className="indent-level-two mb-15">
                            <div className='bold'>5.認定個人情報保護団体</div>
                            <div className="indent-level-one" >
                                【認定個人情報保護団体の名称及び苦情の解決の申出先】<br />
                                ※個人情報の取り扱いに関する苦情のみを受付けています<br />
                                一般財団法人日本情報経済社会推進協会<br />
                                認定個人情報保護団体事務局<br />
                                〒106-0032 東京都港区六本木一丁目９番９号 六本木ファーストビル内<br />
                                TEL：03-5860-7565 ／ 0120-700-779
                            </div>
                        </div>

                        <div className="indent-level-two mb-15">
                            <div className='bold'>6.保有個人データ又は第三者提供記録の開示等の求めに応じる手続き</div>
                            <div className="indent-level-one" >
                                1)開示等の求めの申し出先<br />
                                　開示等のお求めは、上記個人情報問合せ窓口にお申し出ください。<br />
                                　※電磁的手続きによる開示等をご希望の方は、その旨お申し出ください。<br />
                                　※原則としてご希望に沿って対応させていただきます。<br />
                                <br />
                                2)開示等の求めに関するお手続き<br />
                                　①お申し出受付け後、当社からご利用いただく所定の請求書様式「保有個人データ開示等請求書」を郵送いたします。<br />
                                　②ご記入いただいた請求書、代理人によるお求めの場合は代理人であることを確認する書類、手数料分の郵便為替 （利用目的の通知並びに開示の請求の場合のみ）を上記個人情報問合せ係までご郵送ください。<br />
                                　③上記請求書を受領後、ご本人確認のため、当社に登録していただいている個人情報のうちご本人確認可能な2項目程度 （例：電話番号と生年月日等）の情報をお問合せさせていただきます。<br />
                                　④回答は原則としてご本人に対して書面（封書郵送）にておこないます。<br />
                                <br />
                                3)代理人によるお求めの場合、代理人であることを確認する資料<br />
                                　開示等をお求めになる方が代理人様である場合は、代理人である事を証明する資料及び代理人様ご自身を証明する資料を同封してください。各資料に含まれる本籍地情報は都道府県までとし、 それ以降の情報は黒塗り等の処理をしてください。また各資料は個人番号を含まないものをお送りいただくか、全桁を墨塗り等の処理をしてください。<br />
                                　①	　代理人である事を証明する資料<br />
                                　＜開示等の求めをすることにつき本人が委任した代理人様の場合＞<br />
                                　本人の委任状（原本）<br />
                                　＜代理人様が未成年者の法定代理人の場合＞いずれかの写し<br />
                                　戸籍謄本<br />
                                　住民票（続柄の記載されたもの）<br />
                                　その他法定代理権の確認ができる公的書類<br />
                                　＜代理人様が成年被後見人の法定代理人の場合＞いずれかの写し<br />
                                　後見登記等に関する登記事項証明書<br />
                                　その他法定代理権の確認ができる公的書類<br />
                                　②	　代理人様ご自身を証明する資料<br />
                                　運転免許証<br />
                                　パスポート<br />
                                　健康保険の被保険者証<br />
                                　住民票<br />
                                4)利用目的の通知または開示のお求めについての手数料<br />
                                　1回のお求めにつき1000円<br />
                                　（紙面でのご請求の場合は、お送りいただく請求書等に郵便為替を同封していただきます。<br />
                                　その他の方法でご請求いただく場合は、ご請求時にご相談させていただきます。）
                            </div>
                        </div>

                        <div className="indent-level-two mb-15">
                            <div className='bold'>7.個人情報の取扱体制や講じている措置の内容</div>
                            <div className="indent-level-one" >
                                1)基本方針の策定<br />
                                　個人データの適正な取扱いの確保のため、「関係法令・ガイドライン等の遵守」、 「質問及び苦情処理の窓口」等について「個人情報保護方針」を策定しています。<br />
                                2)個人データの取扱いに係る規律の整備<br />
                                　保有個人データは取得、利用、保存、提供、削除・廃棄等の段階ごとに、取扱方法、責任者・担当者及びその任務等について個人情報保護規程を策定しています。<br />
                                3)組織的安全管理措置<br />
                                　①個人データの取扱いに関する責任者を設置するとともに、個人データを取り扱う従業者及び当該従業者が取り扱う個人データの範囲を明確化し、法や取扱規程に違反している事実又は兆候を把握した場合の責任者への報告連絡体制を整備しています。<br />
                                　②個人データの取扱状況について、定期的に自己点検を実施するとともに、他部署や外部の者による監査を実施しています。<br />
                                4)人的安全管理措置<br />
                                　①個人データの取扱いに関する留意事項について、従業者に定期的な研修を実施しています。<br />
                                　②個人データを含む秘密保持に関する誓約書の提出を全従業者から受けています。<br />
                                5)物理的安全管理措置<br />
                                　①個人データを取り扱う区域において、従業者の入退室管理及び持ち込む機器等の制限を行うとともに、権限を有しない者による個人データの閲覧を防止する措置を講じています。<br />
                                　②個人データを取り扱う機器、電子媒体及び書類等の盗難又は紛失等を防止するための措置を講じるとともに、事業所内の移動を含め、当該機器、電子媒体等を持ち運ぶ場合、容易に個人データが判明しないよう措置を講じています。<br />
                                6)技術的安全管理措置<br />
                                　①アクセス制御を実施して、担当者及び取り扱う個人情報データベース等の範囲を限定しています。<br />
                                　②個人データを取り扱う情報システムを外部からの不正アクセス又は不正ソフトウェアから保護する仕組みを導入しています。
                            </div>
                        </div>
                    </div>

                    <div className="right-align">以上</div>
                </div>
            </div>
        </div>
    );
}

export default TermsAndConditions;